
document.addEventListener('DOMContentLoaded',function(){
  var nv=document.getElementById('SiteHeader');
  if(nv){
    var navTick=false,navState=null;
    var syncNav=function(){var next=window.scrollY>30;if(next!==navState){nv.classList.toggle('scrolled',next);navState=next;}navTick=false;};
    window.addEventListener('scroll',function(){if(!navTick){navTick=true;requestAnimationFrame(syncNav);}},{passive:true});
    syncNav();
  }
  var bg=document.getElementById('burger'),mm=document.getElementById('MobileMenu');
  if(bg&&mm){bg.addEventListener('click',function(){mm.classList.toggle('open');});
    mm.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){mm.classList.remove('open');});});}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
  document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
  var cio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var el=e.target,t=parseFloat(el.dataset.count),suf=el.dataset.suffix||'',n=0,st=t/56;var tk=function(){n+=st;if(n<t){el.textContent=Math.floor(n).toLocaleString();requestAnimationFrame(tk);}else{el.textContent=t.toLocaleString()+suf;}};tk();cio.unobserve(el);}});},{threshold:.5});
  document.querySelectorAll('[data-count]').forEach(function(el){cio.observe(el);});
  // faq
  document.querySelectorAll('.q>button').forEach(function(b){b.addEventListener('click',function(){var q=b.parentElement,open=q.classList.contains('open');var scope=q.closest('.faq')||document;scope.querySelectorAll('.q').forEach(function(x){x.classList.remove('open');});if(!open)q.classList.add('open');});});
  // product filters
  document.querySelectorAll('[data-filterset]').forEach(function(set){
    set.querySelectorAll('.filt').forEach(function(f){f.addEventListener('click',function(){
      set.querySelectorAll('.filt').forEach(function(x){x.classList.remove('on');});f.classList.add('on');
      var v=f.dataset.filter,grid=set.parentElement.querySelector('.pgrid');if(!grid)return;
      grid.querySelectorAll('[data-cat]').forEach(function(c){c.style.display=(v==='All'||c.dataset.cat===v)?'':'none';});
    });});
  });
  // pdp gallery
  var slides=document.querySelectorAll('.gmain-slide'),thumbs=document.querySelectorAll('.thumb');
  thumbs.forEach(function(t){t.addEventListener('click',function(){var i=t.dataset.i;thumbs.forEach(function(x){x.classList.remove('on');});t.classList.add('on');slides.forEach(function(s){s.classList.toggle('on',s.dataset.i===i);});});});
  var qi=document.getElementById('Quantity');
  document.querySelectorAll('.qty button').forEach(function(b){b.addEventListener('click',function(){if(!qi)return;var v=parseInt(qi.value||'1')+parseInt(b.dataset.step);if(v<1)v=1;qi.value=v;});});
  // vagaro inject (any http/https origin)
  var mount=document.getElementById('vagaroMount');
  if(mount && /^https?:$/.test(location.protocol)){
    var f=document.createElement('iframe');f.src=mount.dataset.widget;f.title='Book at All About You Beauty Salon';f.setAttribute('scrolling','yes');f.loading='lazy';
    f.onload=function(){f.classList.add('loaded');var fb=document.getElementById('vgfb');if(fb)fb.style.display='none';};
    mount.appendChild(f);
    // If Vagaro posts a content height, grow the frame to fit (removes inner scroll when supported)
    window.addEventListener('message',function(e){
      if(typeof e.data==='undefined')return;
      var h=null;
      if(typeof e.data==='number'){h=e.data;}
      else if(typeof e.data==='string'&&/^\d+$/.test(e.data)){h=parseInt(e.data);}
      else if(e.data&&typeof e.data==='object'){h=e.data.height||e.data.frameHeight||(e.data.arguments&&e.data.arguments[0]);}
      if(h&&h>600&&h<12000){f.style.height=h+'px';}
    });
  }
});

document.addEventListener('DOMContentLoaded',function(){
  var pop=document.getElementById('PromoPop');
  if(!pop)return;
  var KEY='aay_promo_dismissed',off=false;
  try{off=localStorage.getItem(KEY)==='1';}catch(e){}
  if(off)return;
  var delay=(parseFloat(pop.dataset.delay)||6)*1000;
  setTimeout(function(){pop.classList.add('show');},delay);
  var x=document.getElementById('PromoPopX');
  if(x)x.addEventListener('click',function(){pop.classList.remove('show');try{localStorage.setItem(KEY,'1');}catch(e){}});
});
